import styled from 'styled-components';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { CloudImage } from '@components/CloudImage';
import { Columns } from '@components/Columns';
import { themeSpace, themeMediaQuery, themeVariant } from '@utils/styledTheme.util';

// Main wrapper of home-newsroom styled tag
export const MainWrapper = styled(Box)`
  margin: ${themeSpace(0)} auto;
`;

// Content wrapper of home-newsroom styled tag
export const ContentWrapper = styled(Box)`
  margin: ${themeSpace(0)} auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${themeMediaQuery('mobile')} {
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: ${themeSpace(5)} !important;
    padding-bottom: ${themeSpace(5)} !important;
  }
`;

// Box Image wrapper of home-newsroom styled tag
export const ImageWapper = styled.div`
  text-align: center;
  padding-top: ${themeSpace(10)};
  padding-bottom: ${themeSpace(8)};
  img {
    filter: brightness(0);
  }
  ${themeMediaQuery('below_sm')} {
    padding-top: ${themeSpace(7)};
    padding-bottom: ${themeSpace(7)};
  }
  ${themeMediaQuery('mobile')} {
    img {
      max-width: 120px;
    }
  }
`;

// Quote or message wrapper styled tag
// Component uses hed56 (56px) as base variant
export const QuoteWrapper = styled('div')`
  text-align: center;
  margin: ${themeSpace(0)} auto;
  margin: 0 ${themeSpace(11)} ${themeSpace(10)};
  max-width: 663px;

  /* Default override: 36px for all sizes */
  h2 {
    font-size: 36px;
    line-height: 44px;
  }

  /* XL gets hed40 (40px) */
  ${themeMediaQuery('xl')} {
    h2 {
      ${themeVariant('hed40')};
    }
  }

  ${themeMediaQuery('below_sm')} {
    width: 100%;
    max-width: 480px;
    margin: ${themeSpace(0)} auto;
    margin-bottom: 1rem;
  }

  /* Mobile gets 28px */
  ${themeMediaQuery('mobile')} {
    h2 {
      font-size: 28px;
      line-height: 36px;
    }
  }
`;

// Logo Wrapper styled tag
export const LogoWrapper = styled(Flex)`
  margin: ${themeSpace(0)} ${themeSpace(8)} auto;
  max-width: 100%;
  overflow: hidden;
  transform: scale(0.9);
  transform-origin: center center;
  ${themeMediaQuery('lg')} {
    transform: scale(1);
  }
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    flex-wrap: nowrap;
    justify-content: center;
    transform: scale(0.85);
    gap: ${themeSpace(4)}; /* 12px breathing room between logos */
  }
  ${themeMediaQuery('mobile')} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    transform: scale(1);
    gap: ${themeSpace(5)};
    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: ${themeSpace(3)};
    }
  }
`;

export const ColumnWrapper = styled(Columns.Column)`
  width: 100%;
`;

export const ColumnsWrapper = styled(Columns)`
  max-width: 100%;
  ${themeMediaQuery('below_sm')} {
    max-width: unset;
  }
`;

// Type defined for custom props with readonly property
type CloudVariant = Readonly<{
  padding: string;
}>;

// Custom cloud s3 image wrapper styled tag
export const CustomCloudImage = styled(CloudImage).attrs(({ padding }: CloudVariant) => ({
  padding,
}))`
  padding: ${(props) => props.padding};
  width: 230px;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    padding: 15px 10px;
  }
`;
